const t_clickSync_disabled = Lang.langGet('click & sync disabled');
const t_clickSync_default = Lang.langGet('acts as a button (for interactive events)');
const t_clickSync_back = Lang.langGet('"back"-button');
const t_clickSync_next = Lang.langGet('"next"-button');
const t_clickSync_pause = Lang.langGet('"pause"-button');
const t_clickSync_play = Lang.langGet('"play"-button');
const t_clickSync_play_pause = Lang.langGet('"play/pause"-button');
const t_clickSync_restart = Lang.langGet('"restart"-button');
const t_clickSync_stop = Lang.langGet('"stop"-button');
const t_clickSync_step_back = Lang.langGet('"step back"-button');
const t_clickSync_step_forward = Lang.langGet('"step forward"-button');
const t_clickSync_volume_up = Lang.langGet('volume up');
const t_clickSync_volume_down = Lang.langGet('volume down');
const t_clickSync_volume_mute = Lang.langGet('volume mute');

export const CLICK_SYNC_DISABLED_ID = 1;
export const CLICK_SYNC_DEFAULT_ID = 2;

export const clickSyncItems = [
    {value: t_clickSync_disabled, id: CLICK_SYNC_DISABLED_ID},
    {value: t_clickSync_default, id: CLICK_SYNC_DEFAULT_ID},
    {value: t_clickSync_back, id: 3},
    {value: t_clickSync_next, id: 4},
    {value: t_clickSync_pause, id: 5},
    {value: t_clickSync_play, id: 6},
    {value: t_clickSync_play_pause, id: 7},
    {value: t_clickSync_restart, id: 8},
    {value: t_clickSync_stop, id: 9},
    {value: t_clickSync_step_back, id: 10},
    {value: t_clickSync_step_forward, id: 11},
    {value: t_clickSync_volume_up, id: 12},
    {value: t_clickSync_volume_down, id: 13},
    {value: t_clickSync_volume_mute, id: 14},
];

export function constructTriggers(templateElements) {
    return templateElements
        .filter(element => element.clickSync === CLICK_SYNC_DEFAULT_ID)
        .map(element => {
            return {
                value: element.description,
                id: element.unique_id || element.id
            };
        });
}
